import { downgradeComponent } from "@angular/upgrade/static";
import { FoundationAuditNotesListComponent } from "@foundation/_components/notesAuditList/notes-audit-list.component";
import { SimStatusInfoComponent } from "@foundation/_components/simStatusInfo/simStatusInfo.component";
import * as angular from "angular";
import { CameraDeviceInfoComponent } from "./cameraDeviceInfo/cameraDeviceInfo.component";
import { DeviceSummaryComponent } from "./device-summary/device-summary.component";
import { FormWarningComponent } from "./formWarning/formWarning.component";
import { InfoEntryComponent } from "./infoEntry/infoEntry.component";
import { FoundationNotesListComponent } from "./foundation-notes-list/foundation-notes-list.component";
import { SDCardInfoComponent } from "./sdCardInfo/sdCardInfo.component";
import { CommandSenderComponent } from "@foundation/_components/commandSender/commandSender.component";
import { CustomerNameComponent } from "@foundation/_components/customer-name/customer-name.component";
import { BarcodeScannerComponent } from "./barcode-scanner/barcode-scanner.component";
import { ConfigSwitcherComponent } from "./configSwitcher/config-switcher.component";
import { Diagnostics4gComponent } from "./diagnostics4G/diagnostics-4g.component";
import { Commission4gCheckComponent } from "./diagnostics4G/commission4gCheck/commission-4g-check.component";

angular
    .module("app.foundation.components", ["app.directives"])

    .directive("configSwitcher", downgradeComponent({ component: ConfigSwitcherComponent }))
    .component("foundationInfoEntry", new InfoEntryComponent())
    .component("foundationSDCardInfo", new SDCardInfoComponent())
    .component("foundationFormWarning", new FormWarningComponent())
    .component("cameraDeviceInfo", new CameraDeviceInfoComponent())
    .directive("foundationNotesAuditList", downgradeComponent({ component: FoundationAuditNotesListComponent }))
    .directive("deviceSummary", downgradeComponent({ component: DeviceSummaryComponent }))
    .directive("foundationNotesList", downgradeComponent({ component: FoundationNotesListComponent }))
    .directive("customerName", downgradeComponent({ component: CustomerNameComponent }))
    .directive("barcodeScanner", downgradeComponent({ component: BarcodeScannerComponent }))
    .directive("diagnostics4g", downgradeComponent({ component: Diagnostics4gComponent }))
    .directive("commission4gCheck", downgradeComponent({ component: Commission4gCheckComponent }))

    .directive("simStatusInfo", downgradeComponent({ component: SimStatusInfoComponent }))
    .directive("foundationCommandSender", downgradeComponent({ component: CommandSenderComponent }))
    ;
